import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=7707d0fb&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7707d0fb')) {
      api.createRecord('7707d0fb', component.options)
    } else {
      api.reload('7707d0fb', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=7707d0fb&", function () {
      api.rerender('7707d0fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SvDqDl83re7W/JS/offershelp.vue"
export default component.exports